import { CUSTOMIZABLE_LOCATIONS } from '../data/static/CustomizableLocations';
export const isCustomizableLocation = maybeCustomizableLocation => {
  return CUSTOMIZABLE_LOCATIONS.includes(maybeCustomizableLocation);
};